import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesCatalogos() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: null, items: [
      { label: "Departamentos", icon: "fas fa-clipboard-list", color: "#64748b", href: "/Departamentos", desc: "Departamentos", enabled: !!user.menu_departamentos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Catálogos"
      descripcion="Catalogos generales del sistema"
      icono="fas fa-clipboard-list"
      color="#64748b"
      secciones={SECCIONES}
    />
  );
}

export default BotonesCatalogos;
